import React, { useEffect } from 'react';

const TourChapterModal = ({ isOpen, onClose, chapters, onSelectChapter }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const fullTourSteps = Object.values(chapters).flat();

  return (
    <div className="tour-chapter-modal-overlay" onClick={onClose}>
      <div className="tour-chapter-modal-content" onClick={e => e.stopPropagation()}>
        <div className="tour-chapter-modal-header">
          <h2>Choose Your Tour</h2>
          <button title="Close" onClick={onClose} className="icon-button close-button"><i className="material-icons">close</i></button>
        </div>
        <ul className="tour-chapter-list">
          <li onClick={() => onSelectChapter(fullTourSteps, 'Full Tour')}>
            <i className="material-icons">explore</i>
            <span>The Full Journey</span>
          </li>
          {Object.entries(chapters).map(([name, steps]) => (
            <li key={name} onClick={() => onSelectChapter(steps, name)}>
              <i className="material-icons">play_circle_outline</i>
              <span>{name}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TourChapterModal;